var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 11",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.477 10.023q-.271-.27-.06-.541l3.462-3.826H.406q-.405 0-.406-.406 0-.405.406-.406H14.88l-3.402-3.758q-.306-.304 0-.61.305-.305.609 0l4.062 4.47q.102.101.102.304t-.102.305l-4.062 4.468q-.102.102-.305.102t-.304-.102z"
})));
export default SvgArrowRight;